import { render, staticRenderFns } from "./BlogPostDetailsCard.vue?vue&type=template&id=d84b7dfa"
import script from "./BlogPostDetailsCard.vue?vue&type=script&lang=js"
export * from "./BlogPostDetailsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports